import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SmartHomeComponentsApiPicker } from '@vi-iot/client';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { ViToastService } from '@vi-iot/ui';
import { UIService } from '@services';
import { TranslateService } from '@ngx-translate/core';
import { SmartHomeComponentsActions } from './smart-home-components.actions';

@Injectable()
export class SmartHomeComponentsEffects {
  getSmartHomeComponents$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(SmartHomeComponentsActions.getSmartHomeComponents),
      switchMap((action) =>
        this.api
          .instance()
          .listSmartHomeComponents(action.installationId)
          .pipe(
            map((response) =>
              SmartHomeComponentsActions.getSmartHomeComponentsSuccess({
                smartHomeComponents: response.data,
              })
            ),
            catchError((err) => of(SmartHomeComponentsActions.getSmartHomeComponentsError(err)))
          )
      )
    );
  });

  updateSmartHomeComponents$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(SmartHomeComponentsActions.updateSmartHomeComponents),
      tap(() => this.uiService.blockUI()),
      switchMap((action) =>
        this.api
          .instance()
          .updateSmartHomeComponents(action.installationId, action.smartHomeComponents)
          .pipe(
            tap(() => {
              this.toastService.info({
                message: this.translateService.instant(
                  '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.SMART_HOME_COMPONENTS_UPDATE_SUCCESS'
                ),
              });
              this.uiService.unblockUI();
            }),
            map((response) =>
              SmartHomeComponentsActions.updateSmartHomeComponentsSuccess({
                smartHomeComponents: response.data,
              })
            ),
            catchError((err) => {
              this.uiService.unblockUI();
              this.toastService.error({
                message: this.translateService.instant(
                  '+INSTALLATIONS.INSTALLATION.SMART_HOME_COMPONENT.SMART_HOME_COMPONENTS_UPDATE_ERROR'
                ),
              });

              return of(SmartHomeComponentsActions.updateSmartHomeComponentsError(err));
            })
          )
      )
    );
  });

  constructor(
    private api: SmartHomeComponentsApiPicker,
    private actions$: Actions,
    private toastService: ViToastService,
    private uiService: UIService,
    private translateService: TranslateService
  ) {}
}
